/**
 * 菜单项：高亮文档名
*/
import { Controller, Menu } from '@tencent/workbench';
import { MENU_CONFIGS } from '@framework/workbench/ui/add-revision/config';
import { AddRevisionFeature } from '../titlebar/features/add-revision-feature';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';

@Controller({ menuItems: MENU_CONFIGS })
export class AddRevisionController {
    public constructor(private readonly addRevisionFeature: AddRevisionFeature) {}

    @Menu(ActionType.ADD_REVISION, 'shouldHide')
    public shouldHide(): boolean {
        return this.addRevisionFeature.shouldHide();
    }

    @Menu(ActionType.ADD_REVISION, 'onClick')
    public clickAddRevision(): void {
        this.addRevisionFeature.clickAddRevision();
    }
}
